import useStyle from "./useStyle"
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward"
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  loadingOff,
  loadingOn,
  suscribersDetailsStatusOrderByDateVESuccess,
} from "../../../../redux/actions/eventanilla"

function TableHeader({ orderDesc }) {
  const classes = useStyle()
  const dispatch = useDispatch()

  const details = useSelector((state) => state.eventanilla.detailsSubscription)

  const [order, setorder] = useState("desc")

  const changeOrderByDate = (list) => {
    dispatch(loadingOn())
    dispatch(
      suscribersDetailsStatusOrderByDateVESuccess({
        ...details,
        statusHistory: list,
      }),
    )
    dispatch(loadingOff())
  }

  const getOrderList = (orderType) => {
    const prop = "lastStatusChangeDate"

    return details.statusHistory.sort((a, b) => {
      const fechaA = new Date(a[prop])
      const fechaB = new Date(b[prop])
      if (fechaA > fechaB) {
        return orderType === "asc" ? 1 : -1
      } else if (fechaA < fechaB) {
        return orderType === "asc" ? -1 : 1
      }
      return 0
    })
  }
  const changeOrderDesc = () => {
    const newOrder = order === "desc" ? "asc" : "desc"
    setorder(newOrder)
    const newList = getOrderList(newOrder)
    changeOrderByDate(newList)
  }
  return (
    <thead className={classes.row}>
      <tr>
        <th className={classes.headStatus}>Estado</th>
        <th className={classes.headDate} onClick={changeOrderDesc}>
          Fecha
          {orderDesc ? (
            order === "desc" ? (
              <ArrowDownwardIcon style={{ fontSize: 20 }} />
            ) : (
              <ArrowUpwardIcon style={{ fontSize: 20 }} />
            )
          ) : (
            <></>
          )}
        </th>
        <th className={classes.headName}>Operador</th>
      </tr>
    </thead>
  )
}

export default TableHeader
